import { ArticleDto, ProjectDto, SiteDto, SiteType } from '../../api/ClientApi';
import { CompareTwoDates } from '../../common/datesHelper';

export type ProjectTableInfo = {
    siteId?: number;
    siteName?: string;
    siteType?: SiteType;
    address?: string;
};

export function createProjectData(projectId?: number, projectName?: string, siteInfo?: ProjectTableInfo[]) {
    return { projectId, projectName, siteInfo: siteInfo };
}

export const currProjectTableRows = (projects: ProjectDto[] | null, projectFilter: string, siteFilter: string) => {
    if (!projects) {
        return [];
    }
    const row = projects
        ?.filter((p) => {
            return p.name?.toLowerCase().includes(projectFilter.toLowerCase());
        })
        .filter((p) => {
            if (!siteFilter || siteFilter.trim() === '') {
                return true;
            }

            const filteredSites = p.sites?.filter((s) => s.name?.toLowerCase().includes(siteFilter.toLowerCase()));

            if (!!filteredSites && filteredSites.length > 0) {
                return true;
            } else {
                return false;
            }
        })
        ?.map((project) => {
            const sitesInfo = project?.sites?.map((site) => {
                return {
                    siteId: site.id,
                    address: site.locationInfo?.address,
                    siteName: site.name,
                    siteType: site.siteType,
                } as ProjectTableInfo;
            });

            return createProjectData(project.id, project.name, sitesInfo);
        });

    return row ? [...row] : [];
};
